import React from 'react';

export function TabContent({ children }) {
    return (
        <div className="tabs-content container-flex">
            {children}
        </div>
    );
}
